// TODO: Move to .env file after Dockerfile is ready
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL as string

export const BASE_URLS = {
    WEB_PAGE: "/web-page",
    WEB_PAGE_COMPONENT: "/web-page-component",
    PROCESS_INSTANCE: "/process-instance",
    PROCESS_INSTANCE_SLUG: "/process-instance/slug",
    PROCESS_INSTANCE_UPDATE_FIELD: "/process-instance/update-field",
    NAVIGATION_NEXT: "/navigation/next",
    NAVIGATION_PREV: "/navigation/previous",
    NAVIGATION_SPECIFIC_STEP: "/navigation/specific-step",
    NAVIGATION_SPECIFIC_STEP_CODE: "/navigation/specific-step-code",
    ACTION_API_CALL: "/action",
    API_CALL: "/action/api-call",
    PRODUCT: "/product",
    HEADER: "/web-page-component/header",
    FOOTER: "/web-page-component/footer",
    VALIDATE_PROMOCODE: "/promocode/validate",
    RATING: "/rating",
    CONTACT_US: "/contact-us",
    CONSULTATION_REQUEST: "/consultation-request",
    DATASTORAGE: "/datastorage",
    BILLING: "/billing",
    DOCUMENT_SERVICE: "/document-service",
    INTEGRATION_LOG: "/integration-log",
    ORDER: "/order"
};

export const RESOURCES_URLS = {
    BASE_URL: "/webshop-resources/resources",
    IMAGES: "/webshop-resources/resources/images",
    DOCUMENTS: "/webshop-resources/resources/images",
    vectors: "/webshop-resources/resources/images",
}
